export default __webpack_public_path__ + "static/media/greenstone.de09ea91.svg";